module.exports = __webpack_public_path__ + "img/salt_3.5c5b2316.png";